<template>
  <v-container fluid grid-list-lg>
    <!-- <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>

    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList" :editClass="selectedClass"></Edit> -->

    <AssignStudent :editDialog="assignStudentDialog" @close="assignStudentClose" @submit="assigntStudentSubmit"
      :SelectedClass="selectedClass"></AssignStudent>

    <v-card :loading="loading" outlined>
      <ListTitle :showBackButton="true" :access="checkRightStatus(25)" title="Departments" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" :items="payees" :search="search" :loading="loading" :sort-by="sortBy"
        :page.sync="page" :expanded.sync="expanded" show-expand :items-per-page="itemsPerPage">
        <template v-slot:item="{ item, isExpanded, expand }">
          <tr class="pointer">
            <td class="text-left">
              <v-btn @click="expand(true)" icon v-if="!isExpanded"><v-icon>mdi-chevron-down</v-icon></v-btn>
              <v-btn @click="expand(false)" icon v-if="isExpanded"><v-icon>mdi-chevron-up</v-icon></v-btn>
            </td>
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ item.defaultFee | currency }}</td>
            <td class="text-center">
              {{ item.studentCount }}
            </td>
            <td class="text-right">
              {{ item.defaultFee * item.studentCount | currency }}
            </td>
            <td class="text-right">
              {{ item.totalParentPay | currency }}
            </td>
            <td class="text-right">
              {{ item.totalCharity | currency }}
            </td>

            <td class="text-right">
              {{ (item.defaultFee * item.studentCount) - item.totalParentPay - item.totalCharity | currency }}
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="assignStudent(item)">
                    <v-list-item-title>Assign Student</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item v-if="checkRightStatus(27)" @click="editClass(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="checkRightStatus(28)" @click="deletePayee(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0">
            <v-card color="#F3F8FC" text class="elevation-0">
              <v-expansion-panels flat class="pa-2">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Class Rooms
                  </v-expansion-panel-header>
                  <v-divider></v-divider>
                  <v-expansion-panel-content>
                    <v-card color="#F3F8FC" text class="elevation-0">
                      <ClassRoomList :ClassId="item.id" />
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Students
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card color="#F3F8FC" text class="elevation-0">
                      <StudentList :ClassId="item.id" />
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import classService from "@/modules/Classes/service.js";
import { mapGetters } from "vuex";

// const Create = () => import("./Create");
// const Edit = () => import("./Edit");
const AssignStudent = () =>
  import("@/modules/Classes/components/AssignStudent.vue");
// const ClassStudentList = () =>
//   import("@/modules/Student/components/ClassStudentList");
const ClassRoomList = () =>
  import("@/modules/ClassRoom/components/List.vue");

const StudentList = () =>
  import("@/modules/Student/components/List.vue");

export default {
  name: "class-list",
  data() {
    return {
      expanded: [],
      singleExpand: false,
      createDialog: false,
      assignStudentDialog: false,
      selectedTeacher: null,
      selectedStudent: null,
      editDialog: false,
      selectedClass: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Fee",
          align: "left",
          value: "defaultFee",
          sortable: true,
        },
        {
          text: "Student Count",
          align: "center",
          value: "studentCount",
          sortable: true,
        },
        {
          text: "Total Fee",
          align: "right",
          value: "teacherCount",
          sortable: true,
        },
        {
          text: "Parent Paying",
          align: "right",
          value: "teacherCount",
          sortable: true,
        },
        {
          text: "Charity",
          align: "right",
          value: "totalCharity",
          sortable: true,
        },
        {
          text: "Sponsor Need",
          align: "right",
          value: "teacherCount",
          sortable: true,
        },
        {
          text: "",
          width: "20px",
          value: "action",
          sortable: false,
        },
      ],
      payees: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: ['name'],
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Class List";
  },
  components: {
    ClassRoomList,
    StudentList,
    // Create,
    // Edit,
    AssignStudent,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    assigntStudentSubmit() {
      this.assignStudentDialog = !this.assignStudentDialog;
      this.getList();
    },
    assignStudent(val) {
      this.selectedClass = val;
      this.assignStudentDialog = !this.assignStudentDialog;
    },
    assignStudentClose() {
      this.selectedStudent = null;
      this.assignStudentDialog = !this.assignStudentDialog;
    },
    // add() {
    //   this.createDialog = !this.createDialog;
    // },
    add() {
      this.$router.push({
        path: '/departments/create',
      });
    },
    getList() {
      this.loading = true;
      this.editDialog = false
      this.createDialog = false
      return classService.getAll().then((response) => {
        console.log("response", response);
        this.loading = false;
        this.payees = response.data;
        return response;
      });
    },
    editClass(val) {
      // this.selectedClass = val;
      // this.editDialog = !this.editDialog;
      this.$router.push({
        path: `/departments/${val.id}/edit`,
      });
    },
    deletePayee(payee) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          classService.delete(payee.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Payee has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
